export default __webpack_public_path__ + "static/media/download.a9e58c55.svg";